import React from 'react';

import { DashboardCard } from '../../_core/_ui/dashboard-card.component';
import { SectionHeading, Text } from '../../_core/_ui/typography.component';
import { IParentPlayerProfile } from '../../../lib/types';
import { AssessmentRow } from './assessment-row.component';

interface IParentPlayerCardProps {
  // The player's display name, derived from the server-side group; passed in
  // by the page so the card itself stays decoupled from the grouping shape.
  displayName: string;
  profile: IParentPlayerProfile;
  showPastTeams: boolean;
  currentYear: number;
}

export const ParentPlayerCard: React.FC<IParentPlayerCardProps> = ({
  displayName, profile, showPastTeams, currentYear,
}) => {
  const visibleRows = showPastTeams
    ? profile.assessments
    : profile.assessments.filter((row) => row.year === currentYear);

  return (
    <DashboardCard>
      <SectionHeading>
        {displayName}
        <span style={{ color: 'rgba(0, 0, 0, 0.56)', fontWeight: 400 }}> — {currentYear}</span>
      </SectionHeading>

      {visibleRows.length === 0 && !showPastTeams && profile.assessments.length > 0 && (
        <Text>No active teams this year. Toggle &quot;Show past teams&quot; above to see earlier years.</Text>
      )}
      {profile.assessments.length === 0 && (
        <Text>No assessments available yet.</Text>
      )}

      {visibleRows.map((row) => (
        <AssessmentRow key={row._id} row={row} playerName={displayName} />
      ))}
    </DashboardCard>
  );
};
